import axios from "axios";

const tokenRef = { current: null as string | null };

export const setToken = (token: string | null) => {
    tokenRef.current = token;
};

const axiosClient = () => {
    const defaultOptions = {
        baseURL: import.meta.env.DEV ? "/api" : import.meta.env.VITE_API_BASE_URL,
        headers: {
            "Content-Type": "application/json",
        },
    };

    const axiosInstance = axios.create(defaultOptions);

    axiosInstance.interceptors.request.use(async function (config) {
        const token = tokenRef.current || localStorage.getItem("token");
        config.headers.Authorization = token ? `Bearer ${token}` : "";
        return config;
    });

    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401 && !error.config?.url?.includes("/login")) {
                const authMethod = localStorage.getItem("hockeyly_auth_method");
                if (authMethod === "token") {
                    localStorage.removeItem("token");
                    localStorage.removeItem("hockeyly_auth_method");
                    window.location.href = "/login";
                }
            }
            return Promise.reject(error);
        }
    );

    return axiosInstance;
};

export const axiosInstance = axiosClient();
